import { z } from "zod";

export const vesselScanSchema = (t: any, label: string, isDigitsOnly: boolean) =>
  z
    .string()
    .min(1, t("form-validation.required", { label }))
    .max(
      isDigitsOnly ? 8 : 50,
      isDigitsOnly
        ? t("form-validation.max-length-digits", {
            label: t("vessel-call.vessel-scan.imo-number"),
            maxDigits: 8,
          })
        : t("form-validation.max-length", {
            label: t("vessel-call.vessel-scan.vessel-name"),
            max: 50,
          }),
    );
